import { MouseEvent, RefObject, useImperativeHandle, useRef } from 'react';
import { StyledSlotDate, StyledSlotDateName, StyledSlotDateText } from './SlotDate.styles';

interface Props {
  date: DayDate;
  onClick: (date: DayDate) => void;
  isSelected: boolean;
  ref: RefObject<HTMLButtonElement>;
}

const SlotDate = ({ date, onClick, isSelected, ref }: Props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const onClickHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (onClick) {
      onClick(date);
    }
  };

  useImperativeHandle(ref, () => buttonRef.current!, [buttonRef]);

  // TODO - Re-enable auto focus on selected date without breaking B2C-33773
  /*useEffect(() => {
    if (isSelected) {
      // Only focus if not already focused
      if (document.activeElement !== buttonRef.current) {
        buttonRef.current?.focus();
      }
    }
  }, [isSelected]);*/

  return (
    <StyledSlotDate type="button" onClick={onClickHandler} ref={buttonRef} $selected={isSelected}>
      <StyledSlotDateName type="label" size="small" $selected={isSelected}>
        {date.dayName}
      </StyledSlotDateName>
      <StyledSlotDateText type="label" size="small">
        {date.dateText}
      </StyledSlotDateText>
    </StyledSlotDate>
  );
};

export default SlotDate;
